import React from "react";
import { Helmet } from "react-helmet";

import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import HeaderThree from "../../../components/header/HeaderThree";
import FancyTextBlockThree from "../../../components/fancy-text-block/FancyTextBlockThree";
import AboutTabs from "../../../components/block-slider/AboutTabs";
import FancyFeatureTewentyTwo from "../../../components/features/FancyFeatureTewentyTwo";
import Banner from "../../../assets/Sub-component/Banner";
import { Link } from "react-router-dom";

import Accelerated_Design from '../../../assets//Services/Arcviz/Accelerated_Design.svg'
import Competitive from '../../../assets//Services/Arcviz/Competitive-Advantage.svg'
import Cost_and_Time_Savings from '../../../assets//Services/Arcviz/Cost_and_Time_Savings.svg'
import Enhanced_Communication from '../../../assets//Services/Arcviz/Enhanced_Communication.svg'
import Enhanced_Visualization from '../../../assets//Services/Arcviz/Enhanced_Visualization.svg'
import Improved_Decision from '../../../assets//Services/Arcviz/Improved_Decision.svg'
import Increased_Tenant from '../../../assets//Services/Arcviz/Increased_Tenant.svg'
import Streamlined_Transactions from '../../../assets//Services/Arcviz/Streamlined_Transactions.svg'
import Wider_Reach from '../../../assets//Services/Arcviz/Wider_Reach.svg'


import Customized_Training_Modules from '../../../assets/Services/Cogni/Keyfeature/Customized_Training_Modules.svg'
import Data from '../../../assets/Services/Cogni/Keyfeature/Data-Driven_Progress_Tracking.svg'
import Supportive_Community from '../../../assets/Services/Cogni/Keyfeature/Supportive_Community.svg'
import Immersive_VR_Environment from '../../../assets/Services/Cogni/Keyfeature/Immersive_VR_Environment.svg'
import Realistic_Social_Scenarios from '../../../assets/Services/Cogni/Keyfeature/Realistic_Social_Scenarios.svg'
import User_friendly from '../../../assets/Services/Cogni/Keyfeature/User-Friendly_Interface.svg'
import launchingimage from '../../../assets/Launchingimage.png'


const RaidenArcviz = () => {
  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  const benefits = [
    {
      name: "Art Visuals",
      value:
        " Go beyond just imagining; visualize and feel through your eye view of your 2D architectural design.",
      name2: "  Planning",
      value2:
        " Raiden creates VR and 3D models before construction starts, detecting and resolving possible problems to save time, avoid expensive mistakes and misinterpretations, and lower risks. ",
      name3: " Resolutions",
      value3:
        "Entice prospective customers and investors by using virtual reality to showcase models and encourage interaction through immersive experiences.",
    },
  ];

  const FeatureContent = [
    {
      icon: Enhanced_Visualization,
      title: "Enhanced Visualization",
      subTitle: `Creating powerful, realistic architectural visualizations. `,
      bgColor: "#FF4A8B",
    },
    {
      icon: Improved_Decision,
      title: "Improved Decision Making",
      subTitle: `Choose from our personalized options to create your real-time design.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Cost_and_Time_Savings,
      title: "Cost and Time Savings",
      subTitle: `Prevent the need for in-person property viewings and physical staging, as well as save money and time.`,
      bgColor: "#FFB951",
    },
    {
      icon: Wider_Reach,
      title: "Wider Reach",
      subTitle: `Our VR creation impresses clients and potential customers, which also boosts engagement.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Streamlined_Transactions,
      title: "Streamlined Transactions",
      subTitle: `Virtual reality commerce has made real estate transactions, such as buying and selling, easier.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Enhanced_Communication,
      title: "Enhanced Communication",
      subTitle: `Our innovative virtual tours and digital twin technology allow you to connect precisely with project stakeholders.`,
      bgColor: "#FFB951",
    },
    {
      icon: Increased_Tenant,
      title: "Increased Tenant Satisfaction",
      subTitle: `Virtual tours and instructions help tenants gain a comprehensive understanding of their rental property.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Accelerated_Design,
      title: "Accelerated Design Process",
      subTitle: `virtual tools and gear up the design process with real-time analytics and collaborative architecture.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Competitive,
      title: "Competitive Advantage",
      subTitle: `Keep ahead of the competition by offering the experience in a creative and futuristic manner.`,
      bgColor: "#FFB951",
    },
  ];

   const keyfeature = [
    {
      name: "Immersive VR Environment",
      icon:Immersive_VR_Environment,
      description:
        "We encourage you to engage in adventurous interaction, rather than simply following instructions, in a safe environment where you can practice various social situations.",
      // icon: "",
      name2: "Customized Training Modules",
      description2:
        "Our training modules cover everything from basic social interactions to engaging communication strategies that can be customized to meet specific goals and abilities.",
      icon2: Customized_Training_Modules,
      name3: "Realistic Social Scenarios ",
      description3: "Engage with the everyday routines, such as conversation initiation, facial expression interpretation, and social cue navigation, to help users improve their skills with these interactive scenarios. ",
      icon3: Realistic_Social_Scenarios,
      name4: " Data-Driven Progress Tracking",
      description4:
        "We integrate data tracking tools with your system by providing user engagement insights, focus guidance, and lasting updates.",
      icon4: Data,
      name5: "User-Friendly Interface",
      description5:
        "  Our intuitive interface facilitates participation and offers the control, skill level, and unambiguous instructions that are useful for independent learning and exploration.",
      icon5: User_friendly,
      name6: " Supportive Community ",
      description6: "Connect and engage across the community of users and professionals for autism advocacy, sharing experiences, exchanging tips, and celebrating milestones.  ",
      icon6: Supportive_Community,
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
className="Bg-image  z-0"
  alt="Launching"
/>

    <div className=" overflow-hidden ">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white">
        <div
          className=" container   d-flex align-items-center justify-content-center flex-column "
          style={{ minHeight: "100vh",position:'relative'}}
        >
          <h1 className="h1-heading fw-bold text-center">Raiden ARCVIZ</h1>
          <h2 className="my-2 h2-heading">
            {" "}
            Raiden ARCVIZ: Revolutionizing Real Estate & Architecture
          </h2>
          <p className="h1-para text-center mt-4 mb-4">
            VR-powered architecture and real estate that provides immersive
            visualization, interactive design, and effective pre-construction
            and marketing.
          </p>
           <Link to="/request-quote">
          <button
            className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
            style={{ fontSize: 18 }}
            >
            Get Your Free Quote
          </button>
            </Link>
        </div>
      </div>
      <div className=" bg-light">
        <div className=" container pt-50">
          <div className=" row ">
            <h2 className="h2-heading text-center text-lg-start col-12 col-lg-6  ">
              {" "}
              Need for Raiden ARCVIZ
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0">
              Architecting your projects with the enhanced, future-focused
              innovation Virtual Reality (VR) technology. With its modern
              hardware and software, Raiden offers creative services and
              high-quality solutions to meet all real estate and architectural
              needs.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <div className="fancy-text-block-three bg-light mt-80 mart">
          <div className="container">
            <h2 className="text-center h2-heading mb-3 pb-lg-3">
              Unlocking possibilities: Innovative Solutions
            </h2>
            <div className="row">
              <div className="col-xl-11 m-auto">
                <FancyTextBlockThree keyfeature={keyfeature[0]} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className=" container  pt-80 padt pb-80 padb">
          <div className=" row ">
            <h2 className="h2-heading text-center  text-white text-lg-start col-12 col-lg-6  "style={{marginTop:'47px'}}>
              {" "}
              WHO IS Raiden ARCVIZ
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0 text-white opacity-75"style={{marginBottom:'80px'}}>
              Employing virtual reality (VR) technology to revolutionize the
              architecture and real estate sectors with passionate experts who
              are advancing traditional design and visualization methods and
              opening the door for a futuristic approach.
            </p>
          </div>
        </div>
      </div>

      {/* Who Stands to Gain  */}
      <div className="fancy-text-block-twenty pt-80 padt pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="">
                <h2 className="h2-heading text-center text-lg-start mb-2 mb-lg-0">
                  Unlocking possibilities: Innovative Solutions
                </h2>
              </div>
            </div>
            <div className="col-lg-6 ms-auto">
              <AboutTabs benefits={benefits[0]} />
            </div>
          </div>
        </div>
      </div>

      {/* Raiden's Core  */}
      <div className="fancy-feature-twentyTwo mt-200 md-mt-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-md-3 mb-2">
                Experience the Advantage 
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <FancyFeatureTewentyTwo FeatureContent={FeatureContent} />
          </div>
        </div>
      </div>

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      {/* footer */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default RaidenArcviz;
